import type { UnitProgress } from '~/api/documentExtraction';

/** Keys a unit or a row by its file first, since two attachments can share every other part. */
export function sourceKeyOf(documentId: string, ...parts: string[]): string {
  return [documentId, ...parts].join('|');
}

/**
 * An email answers with its attachments' units folded in, and two attachments can both have a
 * page p1, so a unit is named by its file whenever the document spans more than one.
 */
export function sourceLabelerOf(
  units: readonly UnitProgress[]
): (documentId: string, unitLabel: string) => string {
  const filenames = new Map<string, string>();
  for (const unit of units) {
    if (unit.sourceFilename) {
      filenames.set(unit.documentId, unit.sourceFilename);
    }
  }
  const documents = new Set(units.map((unit) => unit.documentId));
  return (documentId, unitLabel) => {
    const filename = filenames.get(documentId);
    return documents.size > 1 && filename
      ? `${filename} · ${unitLabel}`
      : unitLabel;
  };
}
